<template>
  <div id="ammeter">
    <div id="user">
      <div class="clearfix">
        <h3>用户列表</h3>
      </div>
      <div class="there">
        <div class="there-item">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
          <div class="there-btn" @click="inputck"></div>
        </div>
        <el-tree
          class="filter-tree"
          :data="data"
          :props="defaultProps"
          default-expand-all
          :filter-node-method="filterNode"
          ref="tree"
        >
        </el-tree>
      </div>
    </div>
    <div id="text">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="电表设置" name="first">
          <div class="table">
            <div class="input-timer">
              <el-form
                ref="form"
                :model="sizeForm"
                label-width="80px"
                size="mini"
              >
                <el-form-item>
                  <el-select
                    v-model="sizeForm.region"
                    placeholder="请选择活动区域"
                  >
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="sizeForm.region"
                    placeholder="请选择活动区域"
                  >
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="value1"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
                <el-form-item size="large">
                  <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
              </el-form>
              <div class="btn-all">
                <div class="btn-item">
                  <ElectricityPriceSetting></ElectricityPriceSetting>
                  <ArrearsAlarmSetting></ArrearsAlarmSetting>
                  <LackOfSwitch></LackOfSwitch>
                  <SettlementOfClosing></SettlementOfClosing>

                  <el-button type="info">发送报警短信</el-button>
                </div>
                <div class="exc">
                  <div class="logo"></div>
                  <p>导出列表</p>
                </div>
              </div>
            </div>
            <div class="table-user">
              <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="date" label="用户名" width="180">
                </el-table-column>
                <el-table-column prop="name" label="用户号" width="180">
                </el-table-column>
                <el-table-column prop="address" label="电费号">
                </el-table-column>
                <el-table-column prop="address" label="表类型">
                </el-table-column>
                <el-table-column prop="address" label="充值金额">
                </el-table-column>
                <el-table-column prop="address" label="充值方式">
                </el-table-column>
                <el-table-column prop="address" label="时间"> </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="用户开户" name="second">
          <TheUserAccount></TheUserAccount>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import TheUserAccount from "./ammeterComp/TheUserAccount";
import ElectricityPriceSetting from "./ammeterComp/compone/ElectricityPriceSetting";
import ArrearsAlarmSetting from "./ammeterComp/compone/ArrearsAlarmSetting";
import LackOfSwitch from "./ammeterComp/compone/LackOfSwitch";
import SettlementOfClosing from "./ammeterComp/compone/SettlementOfClosing";

export default {
  name: "ammeter",
  components: {
    TheUserAccount,
    ElectricityPriceSetting,
    ArrearsAlarmSetting,
    LackOfSwitch,
    SettlementOfClosing,
  },
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],

      activeName: "second",

      value1: "",
      sizeForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },

      filterText: "",
      data: [
        {
          id: 1,
          label: "东区",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "西区",
          children: [
            {
              id: 5,
              label: "某某大楼",
              children: [
                {
                  id: 11,
                  label: "某某企业",
                },
                {
                  id: 13,
                  label: "某某企业",
                },
              ],
            },
            {
              id: 6,
              label: "某某大楼",
            },
          ],
        },
        {
          id: 3,
          label: "北区",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
        {
          id: 3,
          label: "北区",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
inputck(){
 console.log(this.filterText)
},

    handleClick(tab, event) {
      console.log(tab, event);
    },

    onSubmit() {
      console.log("submit!");
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>
<style lang="less" scoped>
#ammeter {
  width: 100%;
  height: 100%;
  display: flex;

  #user {
    .w(327);
    height: 100%;
    background-color: #fff;

    .clearfix {
      padding: 23rem 0 23rem 24rem;
      border-bottom: 1rem solid rgba(0, 43, 102, 0.28);
      h3 {
        width: 72px;
        height: 18px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
    }
    .there-item {
      display: flex;
      padding-right: 24rem;
      margin-top: 20rem;
      .there-btn {
        .w(20);
        .h(20);
        background-color: red;
        margin-top: 14rem;
      }
    }
  }
  #text {
    height: 100%;
    background-color: #fff;
    .w(1256);
    margin-left: 8rem;
    padding: 0 24rem 23rem 24rem;
    h3 {
      width: 72px;
      height: 18px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    .table {
      margin-top: 23rem;
      .table-user {
        margin-top: 20rem;
      }
      .input-timer {
        .btn-all {
          display: flex;
          justify-content: space-between;
          .btn-item {
            display: flex;
            div {
              border: 1rem black solid;
              // padding: 9rem 18rem 8rem 18rem;
              margin-right: 10rem;
            }
          }
          .exc {
            display: flex;
            margin-top: 4rem;
            .logo {
              .w(22);
              .h(22);
              background-color: red;
              margin-top: 5rem;
            }
            p {
              width: 72px;
              height: 18px;
              font-size: 18px;
              font-weight: 500;
              color: #333333;
              margin-left: 7rem;
              margin-top: 1rem;
            }
          }
        }
      }
    }
  }
}
</style>